import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Link from 'react-router/lib/Link';
import { ChevronLeft } from '../../../../common/fa_icons';
import { sendDataLayerEvent } from '../../../../../utils/analytics';
import {isEmpty} from 'lodash';
import { defineMessages, injectIntl } from 'react-intl';
import { decorateIntlMessages } from '../../../../common/rosetta_formatted_message';

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  previous_slide_link_title: {
    id: 'previous_slide_link_title',
    description: 'Previous slide link title attribute content (Previous Slide)',
    defaultMessage: 'Previous Slide'
  }
}));

class PreviousSlideButton extends PureComponent {
  handleClick = () => {
    sendDataLayerEvent('Click', {
      actionType: 'Previous Slide',
      itemName: 'Slideshow',
      pageModule: 'Slideshow',
      slideshowComponent: 'Navigation'
    });
    this.props.handleClick();
  };

  render() {
    if (isEmpty(this.props.slideLocation)) {
      return null;
    }

    return (
      <Link to={this.props.slideLocation}
        title={this.props.intl.formatMessage(i18nMessages.previous_slide_link_title)}
        onClick={this.handleClick}
        className="nav-left"
      >
        <ChevronLeft />
      </Link>
    );
  }
}

PreviousSlideButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  slideLocation: PropTypes.object,
  intl: PropTypes.object.isRequired
};

export default injectIntl(PreviousSlideButton);
